import isServerSide from '@helpers/misc/isServerSide'

export default function OpenApp({code, playStoreURL, appStoreURL}) {
  const url = navigator.platform.match(/iPhone|iPod|iPad/) ? appStoreURL : playStoreURL
  if (isServerSide()) return null
  window.open(url)
}
